import { useEffect, useState } from "react";
import classNames from "classnames";
import Icon from "./icon";

const TIMEOUT = 5000;

const Toast = ({ message, setToastVisibility }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timerId = setTimeout(() => setVisible(false), TIMEOUT);
    return () => clearTimeout(timerId);
  }, []);

  useEffect(() => {
    const timerId = setTimeout(() => setToastVisibility(false), TIMEOUT + 100);
    return () => clearTimeout(timerId);
  }, [setToastVisibility]);

  return (
    <div className={classNames("toast", visible && "toast--visible")}>
      <Icon name="check" />
      <div className="toast__message">{message}</div>
    </div>
  );
};

export default Toast;
